import createListStore from "../stores/listStoreFactory";

export const useDogStore = createListStore('dog', )

export default useDogStore